import React from 'react';

import GenericModal from 'views/Modals/GenericRevisionHistoryModal';
import PartnerRevisionHistoryTable from 'views/RevisionHistory/Partner/PartnerRevisionHistoryTable';

const RevisionHistoryModal = ({ techId }: { techId: string }) => {
  const content = <PartnerRevisionHistoryTable techId={techId} />;

  return <GenericModal content={content} />;
};
export default RevisionHistoryModal;
